<div class="analysis-root">

  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoadingMetrics">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Yükleniyor...</span>
    </div>
  </div>

  <!-- Empty State: Analiz yapılmamış -->
  <div class="empty-state" *ngIf="!isLoadingMetrics && !hasResults">
    <i class="fa-solid fa-microscope"></i>
    <p>{{ "modelViewer.analysisEmpty" | translate }}</p>
    <span>{{ "modelViewer.analysisEmptyHint" | translate }}</span>
  </div>


  <!-- 3D Model Viewer Section -->
  <div class="analysis-viewer-card" *ngIf="!isLoadingMetrics && hasModels">
    <div class="analysis-viewer-header">
      <span class="analysis-view-label">{{ "modelViewer.models3D" | translate }}</span>
      <div class="analysis-model-tabs">
        <button
          class="analysis-model-tab"
          [class.active]="activeModelTab === 'painted'"
          (click)="activeModelTab = 'painted'"
          *ngIf="wound?.paintedModelPath"
        >{{ "modelViewer.modelsPainted" | translate }}</button>
        <button
          class="analysis-model-tab"
          [class.active]="activeModelTab === 'overlay'"
          (click)="activeModelTab = 'overlay'"
          *ngIf="wound?.overlayModelPath"
        >{{ "modelViewer.modelsOverlay" | translate }}</button>
        <button
          class="analysis-model-tab"
          [class.active]="activeModelTab === 'patch'"
          (click)="activeModelTab = 'patch'"
          *ngIf="wound?.woundPatchPath"
        >{{ "modelViewer.modelsWoundPatch" | translate }}</button>
      </div>
    </div>
    <div class="analysis-viewer-container">
      <app-model-viewer
        [modelUrl]="activeModelUrl ?? null"
        [allowAnnotation]="false"
        [hide2DToolbar]="true"
        [hide3DDeleteButton]="true"
        [showMeasurementSidebar]="activeModelTab === 'overlay' || activeModelTab === 'painted'"
        [woundMetrics]="metrics"
      ></app-model-viewer>
    </div>
  </div>

</div>
